export default "/images/key.svg?c84f399eb45913172488b63da5ef4dc5";